import { FC } from 'react';

import RollbackOperationModalBody from './components/RollbackOperationModalBody';
import RollbackOperationModalFooter from './components/RollbackOperationModalFooter';
import RollbackOperationModalHeader from './components/RollbackOperationModalHeader';

import { useRollbackOperationModal } from './context/RollbackOperationModalContext';

import '../Modals.scss';
import CustomLoading from '../../CustomLoading';

const RollbackOperationModal: FC = () => {
  const { data } = useRollbackOperationModal();

  return (
    <>
      <RollbackOperationModalHeader />
      <RollbackOperationModalBody />
      <RollbackOperationModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default RollbackOperationModal;
